import { useCallback, useRef, useState } from 'react';
import { sessionCheck } from '../../../constants/SnowplowConst';

export function useSessionCheckInStatus() {
    const [sessionCheckInStatus, changeCheckInStatus] = useState(sessionCheck.checkOut);
    const sessionCheckInStatusRef = useRef(sessionCheckInStatus);
    const getSessionCheckInStatus = useCallback(() => sessionCheckInStatusRef.current, []);
    const setSessionCheckInStatus = useCallback((newSessionCheckInStatus) => {
        sessionCheckInStatusRef.current = newSessionCheckInStatus;
        changeCheckInStatus(newSessionCheckInStatus);
    }, []);
    return {getSessionCheckInStatus, setSessionCheckInStatus};
}
